﻿export class booking_confirmation_payment {
    full_payment: boolean = false;
    deposit_payment: boolean = false;
    payment_method: string | null = null
    iso_currency_code: string | null = null
    reference: string | null = null;
}